<template>
  <el-table :data="repos">
    <el-table-column
      prop="title"
      label="资料名"
      :formatter="emptyTextFormatter"
    >
    </el-table-column>
    <el-table-column
      prop="version"
      label="版本号"
      :formatter="emptyTextFormatter"
    >
    </el-table-column>
    <el-table-column
      prop="node"
      label="节点"
      :formatter="emptyTextFormatter"
    ></el-table-column>
    <el-table-column
      v-if="showCreatedAt"
      prop="created_at"
      label="创建时间"
      :formatter="timeFormatter"
    >
    </el-table-column>
    <el-table-column
      v-if="showUpdatedAt"
      prop="updated_at"
      label="最后更新"
      :formatter="timeFormatter"
    >
    </el-table-column>
    <el-table-column
      v-if="showPublishedAt"
      prop="published_at"
      label="发布时间"
      :formatter="timeFormatter"
    >
    </el-table-column>
    <el-table-column prop="tags" align="center" label="标签">
      <template slot-scope="scope">
        <TableTags :tags="scope.row.tags"></TableTags>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="90">
      <template slot-scope="scope">
        <div class="table-actions">
          <i
            class="el-icon-view preview-icon-button"
            @click="
              $router.push({
                name: 'repo_preview',
                params: { repo_id: scope.row.id }
              })
            "
          ></i>
          <i
            class="el-icon-edit-outline icon-button edit-icon-button"
            @click="handleEdit(scope.$index, scope.row)"
            v-show="isSameOwnerOrSuper(scope.row.author.id)"
          ></i>
          <DeleteIconButton
            @delete="handleDelete(scope.row)"
            v-show="isSameOwnerOrSuper(scope.row.author.id)"
          ></DeleteIconButton>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import TableTags from "@/components/TableTags";
import DeleteIconButton from "@/components/DeleteIconButton";
import { ElTableFormatterMixin, ResourceOwnerMixin } from "@/mixins";
export default {
  name: "ReposListAdminTable",
  props: {
    repos: {
      type: Array,
      default: () => []
    },
    showCreatedAt: {
      type: Boolean
    },
    showUpdatedAt: {
      type: Boolean
    },
    showPublishedAt: {
      type: Boolean
    }
  },
  mixins: [ElTableFormatterMixin, ResourceOwnerMixin],
  components: {
    TableTags,
    DeleteIconButton
  },
  methods: {
    handleEdit(idx, repo) {
      this.$router.push({
        name: "admin_repo_edit",
        params: { repo_id: repo.id }
      });
    },
    handleDelete(repo) {
      this.$emit("delete", repo);
    }
  }
};
</script>
